import styled from "styled-components";

export const CardContainer = styled.div`
  display: flex;
  align-items: stretch;
  background: white;
  border-radius: 16px;
  overflow: hidden;
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  padding: 16px 24px;
  flex: 1;
  min-width: 0;
`;

export const AssetClassRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const AssetClassDot = styled.div`
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #82ff6f;
  flex-shrink: 0;
`;

export const AssetClassText = styled.span`
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 11px;
  line-height: 14px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #092d46;
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const DealName = styled.h3`
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 22px;
  line-height: 28px;
  letter-spacing: -0.2px;
  color: #092d46;
  margin: 0;
  white-space: nowrap;
`;

export const TitleDot = styled.div`
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #5c778a;
  flex-shrink: 0;
`;

export const SubHeading = styled.span`
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  color: #5c778a;
  white-space: nowrap;
`;

export const LabelsRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 24px;
`;

export const LabelGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const LabelCaption = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const LabelCaptionText = styled.span`
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #5c778a;
`;

export const LabelValueBold = styled.span`
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.1px;
  color: #092d46;
`;

export const LabelValueMedium = styled.span`
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.2px;
  color: #3a5e78;
`;

export const Divider = styled.div`
  width: 1px;
  height: 32px;
  background: #e7eff4;
  flex-shrink: 0;
`;

export const ImageWrapper = styled.div`
  width: 200px;
  min-width: 200px;
  flex-shrink: 0;
  overflow: hidden;
  background: #e1e8ed;
`;

export const CountdownWrapper = styled.div`
  width: 200px;
  min-width: 200px;
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
`;

export const CountdownOverlay = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 24px 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
`;

export const CountdownOpeningText = styled.span`
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 11px;
  line-height: 14px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #cedbe4;
`;

export const CountdownRow = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;

export const CountdownUnit = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

export const CountdownNumber = styled.span`
  font-family: "Archivo", sans-serif;
  font-weight: 700;
  font-size: 22px;
  line-height: 24px;
  color: #f5f9fb;
  text-align: center;
`;

export const CountdownLabel = styled.span`
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #cedbe4;
`;

